import React from 'react';
import { CTAButton } from './CTAButton';
export function BenefitsSection() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-4">
      <div className="max-w-[680px] mx-auto" data-id="element-5">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray text-center mb-10" data-id="element-6">
          ✅ Dentro de Este Ebook, Aprenderás a:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10" data-id="element-7">
          {/* Card 1 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-50" data-id="element-8">
            <span className="text-pink-dark text-xl mb-2 block" aria-hidden="true" data-id="element-9">
              ✔
            </span>
            <h3 className="font-body font-bold text-dark-gray mb-1" data-id="element-10">
              Tejer tu primera bikini en 24 horas
            </h3>
            <p className="font-body text-medium-gray text-sm" data-id="element-11">
              Terminás lo que empezás — y la usás.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-50" data-id="element-12">
            <span className="text-pink-dark text-xl mb-2 block" aria-hidden="true" data-id="element-13">
              ✔
            </span>
            <h3 className="font-body font-bold text-dark-gray mb-1" data-id="element-14">
              Leer cualquier patrón con confianza
            </h3>
            <p className="font-body text-medium-gray text-sm" data-id="element-15">
              No más sentirte perdida a mitad de camino.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-50" data-id="element-16">
            <span className="text-pink-dark text-xl mb-2 block" aria-hidden="true" data-id="element-17">
              ✔
            </span>
            <h3 className="font-body font-bold text-dark-gray mb-1" data-id="element-18">
              Ajustar el talle para tu cuerpo exacto
            </h3>
            <p className="font-body text-medium-gray text-sm" data-id="element-19">
              Piezas que te quedan a VOS, no a un maniquí.
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-50" data-id="element-20">
            <span className="text-pink-dark text-xl mb-2 block" aria-hidden="true" data-id="element-21">
              ✔
            </span>
            <h3 className="font-body font-bold text-dark-gray mb-1" data-id="element-22">
              Elegir los materiales correctos
            </h3>
            <p className="font-body text-medium-gray text-sm" data-id="element-23">
              Sin gastar plata en hilo que no funciona.
            </p>
          </div>

          {/* Card 5 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-50" data-id="element-24">
            <span className="text-pink-dark text-xl mb-2 block" aria-hidden="true" data-id="element-25">
              ✔
            </span>
            <h3 className="font-body font-bold text-dark-gray mb-1" data-id="element-26">
              Dominar 5 puntos esenciales
            </h3>
            <p className="font-body text-medium-gray text-sm" data-id="element-27">
              Todo lo demás se vuelve fácil después de estos.
            </p>
          </div>

          {/* Card 6 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-50" data-id="element-28">
            <span className="text-pink-dark text-xl mb-2 block" aria-hidden="true" data-id="element-29">
              ✔
            </span>
            <h3 className="font-body font-bold text-dark-gray mb-1" data-id="element-30">
              Lograr terminaciones profesionales
            </h3>
            <p className="font-body text-medium-gray text-sm" data-id="element-31">
              Tus piezas parecen de tienda — porque el método es así de bueno.
            </p>
          </div>

          {/* Card 7 - spans full width on md */}
          <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-50 md:col-span-2" data-id="element-32">
            <span className="text-pink-dark text-xl mb-2 block" aria-hidden="true" data-id="element-33">
              ✔
            </span>
            <h3 className="font-body font-bold text-dark-gray mb-1" data-id="element-34">
              Acceder a +60 diseños únicos
            </h3>
            <p className="font-body text-medium-gray text-sm" data-id="element-35">
              De simple a impresionante — organizados por nivel.
            </p>
          </div>
        </div>
      </div>
    </section>;
}